function nextPostsPage(n) {
	if (
		postPage + n <= Math.ceil(Array.from(postCards).length / limit ) &&
		postPage + n > 0
	) {
		postPage += n;
		displayCards(limit);
		removeAllNumbers();
		renderPosts();
		$("html, body").animate({scrollTop: 0}, 1000);
	}
}
